export const hasActivityAccess = (unit) => {
    const value = unit?.Activity;

    if (value === true || value === 1) {
        return true;
    }

    return typeof value === 'string' && value.trim() === '1';
};
